"use client";

/**
 * PostDetailHeroMedia 컴포넌트
 * @description 글머리의 대표 그림 — 매거진의 첫 장. 조판 폭(1100) 안에서 폰은 3:2, 넓은
 *   화면은 20:9 로 눕혀 가로로 넓게 선다. 스크롤에 맞춰 그림이 느리게 따라온다(`useParallax`).
 *   그림이 없으면 세우지 않는다.
 *
 *   비율이 다른 두 장을 CSS 한 상자로 갈아 끼울 수 없어 상자 둘 중 하나만 보인다.
 */
import { Media } from "@fanwork-web/design-system";
import { memo } from "react";

import { POST_HERO_SIZES, postDetailStyles } from "./PostDetail.styles";
import type { PostDetailHeroMediaProps } from "./PostDetail.types";

import { AppImage, useParallax } from "@/shared/ui";

const PostDetailHeroMedia = memo<PostDetailHeroMediaProps>(({ post }) => {
  const ref = useParallax<HTMLDivElement>();
  if (!post.coverImageUrl) return null;
  const image = (
    <AppImage uri={post.coverImageUrl} sizes={POST_HERO_SIZES} priority />
  );
  return (
    <div ref={ref} className={postDetailStyles.hero}>
      <div className="tablet:hidden">
        <Media ratio="landscape" slot={image} />
      </div>
      <div className="hidden tablet:block">
        <div className={postDetailStyles.heroWide}>{image}</div>
      </div>
    </div>
  );
});

PostDetailHeroMedia.displayName = "PostDetailHeroMedia";

export default PostDetailHeroMedia;
